import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NgbDatepickerConfig, NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import * as moment from 'moment';
import {Helper} from '../../../../helpers/helper.service';
import {LocalizationService} from '../../../../back-office/Services/localization.service';


@Component({
  selector: 'app-ngbd-datepicker-config',
  templateUrl: 'delivery-week.html',
  providers: [NgbDatepickerConfig] // add NgbDatepickerConfig to the component providers
})
export class NgbdDatepickerConfigComponent implements OnInit, OnChanges {
  @Input() lastValue;
  @Input() showWarning;
  @Input() minDeliveryWeek;
  @Output() weekSelected = new EventEmitter<any>();
  public model: NgbDateStruct;

  constructor(
    private config: NgbDatepickerConfig,
    private  calendar: NgbCalendar,
    private localizationService: LocalizationService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.localizationService.getServerDate().subscribe(resp => {
      const currentDate = resp.date;
      const minDeliveryWeek = moment(currentDate).add(this.minDeliveryWeek, 'week');
      const maxDeliveryWeek = moment(minDeliveryWeek).add(5, 'months').add(1, 'week');

      this.config.minDate = {
        year: minDeliveryWeek.year(),
        month: minDeliveryWeek.month() + 1,
        day: minDeliveryWeek.date()
      };

      this.config.maxDate = {
        year: maxDeliveryWeek.year(),
        month: maxDeliveryWeek.month() + 1,
        day: maxDeliveryWeek.date()
      };
    });
  }


  ngOnInit() {
    if (this.lastValue !== undefined) {
      const lastDate = moment(this.lastValue, 'YYYY-MM-DD');
      if (lastDate.isValid()) {
        this.model = {
          month: lastDate.month() + 1,
          day: lastDate.date(),
          year: lastDate.year()
        };
      }
    }
  }

  onDeliveryChange() {
    const date = this.model.year + '-' + this.model.month + '-' + this.model.day;
    const dateSelected = moment(date, 'YYYY-MM-DD');
    const deliveryWeek = 'week ' + dateSelected.week() + ', ' + dateSelected.year();
    this.weekSelected.emit({
      date: date,
      deliveryWeek: deliveryWeek
    });
  }

  isDisabled = (disabled, date: NgbDate, currentMonth) => date.month !== currentMonth || disabled;

  isWeekSelected(date: NgbDate) {
    if (!Helper.isDefined(this.model)) {
      return false;
    }
    const dateString = this.model.year + '-' + this.model.month + '-' + this.model.day;
    const firstDayOfWeek = moment(dateString, 'YYYY-MM-DD').startOf('isoWeek');
    const secondDayOfWeek = moment(firstDayOfWeek).add(1, 'days');
    const thirdDayOfWeek = moment(firstDayOfWeek).add(2, 'days');
    const forthDayOfWeek = moment(firstDayOfWeek).add(3, 'days');
    const fifthDayOfWeek = moment(firstDayOfWeek).add(4, 'days');
    const sixDayOfWeek = moment(firstDayOfWeek).add(5, 'days');
    const endDayOfWeek = moment(firstDayOfWeek).add(6, 'days');
    return (date.day === firstDayOfWeek.date() && (date.month === firstDayOfWeek.month() + 1) && date.year === firstDayOfWeek.year()) ||
      (date.day === secondDayOfWeek.date() && (date.month === secondDayOfWeek.month() + 1) && date.year === secondDayOfWeek.year()) ||
        (date.day === thirdDayOfWeek.date() && (date.month === thirdDayOfWeek.month() + 1) && date.year === thirdDayOfWeek.year()) ||
          (date.day === forthDayOfWeek.date() && (date.month === forthDayOfWeek.month() + 1) && date.year === forthDayOfWeek.year()) ||
            (date.day === fifthDayOfWeek.date() && (date.month === fifthDayOfWeek.month() + 1) && date.year === fifthDayOfWeek.year()) ||
              (date.day === sixDayOfWeek.date() && (date.month === sixDayOfWeek.month() + 1) && date.year === sixDayOfWeek.year()) ||
                (date.day === endDayOfWeek.date() && (date.month === endDayOfWeek.month() + 1) && date.year === endDayOfWeek.year());
  }
}
